import { NotificationType } from '../../screens/MainScreen/NotificationWrapper/NotificationWrapper';
import { NotificationOperation } from './notification.types';

let _id = 0;
const nextId = () => ++_id;

export const types = {
    SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
    SCROLL_TO_TOP: 'SCROLL_TO_TOP',
    CLEAR_NOTIFICATION: 'CLEAR_NOTIFICATION',
};

const showNotification = (
    title: string,
    message: string,
    notificationType?: NotificationType,
    group?: string,
    duration?: number,
    operation?: NotificationOperation,
) => ({
    type: types.SHOW_NOTIFICATION,
    title,
    message,
    notificationType: notificationType || NotificationType.INFO,
    id: nextId(),
    group,
    duration,
    operation,
});

const showErrorNotification = (title: string, message: string) => ({
    type: types.SHOW_NOTIFICATION,
    title,
    message,
    notificationType: NotificationType.ERROR,
    id: nextId(),
});

const showInfoNotification = (
    title: string,
    message: string,
    group?: string,
    duration?: number,
    operation?: NotificationOperation,
) => ({
    type: types.SHOW_NOTIFICATION,
    title,
    message,
    notificationType: NotificationType.INFO,
    id: nextId(),
    group,
    duration,
    operation,
});

const scrollToTop = () => ({
    type: types.SCROLL_TO_TOP,
});

const clearNotification = () => ({
    type: types.CLEAR_NOTIFICATION,
});

export default {
    showNotification,
    showErrorNotification,
    showInfoNotification,
    scrollToTop,
    clearNotification,
} as const;
